import ProjectPlanSelect from './src/main';

/* istanbul ignore next */
ProjectPlanSelect.install = function(Vue) {
  Vue.component(ProjectPlanSelect.name, ProjectPlanSelect);
};

export default ProjectPlanSelect;
